export const navBarBase = "border-b px-5 relative";

export const navBarAdmin = "bg-slate-900";
export const navBarDefault = "bg-transparent";

export const navButtonAdmin =
  "bg-slate-900 focus:bg-slate-900 hover:bg-slate-700/70 text-white hover:text-white focus:text-white select-none rounded-md";

export const navButtonDefault =
  "bg-transparent focus:bg-transparent hover:bg-transparent text-gray-800 hover:text-black/80 focus:text-black/60 select-none rounded-md";


